<script setup lang="ts">
import { LinkTarget } from "~/components/Utils/Markdown.types"
import { NewsProps } from "./News.props"

defineProps<NewsProps>()
</script>

<template>
  <div
    class="
      news-wrapper
      flex
      h-full
      flex-row
      space-x-2
      overflow-hidden
      md:space-x-4
    "
  >
    <div class="bg-grey-main hidden h-full md:block">
      <UtilsWrapperImage
        v-if="image"
        v-bind="image"
        :key="image.image.url"
        class="
          wrapper-image-1
          h-full
          min-h-[100px]
          flex-shrink
          overflow-hidden
          rounded-lg
          p-2
        "
      />
    </div>

    <div class="w-[100%] md:w-[65%]">
      <p v-if="title" class="beaver-bold md:pig-bold">
        {{ title }}
      </p>

      <UtilsMarkdown
        v-if="text"
        :content="text"
        useLinkStyle
        :linkTarget="LinkTarget.blank"
        class="beaver md:pig"
      />
    </div>
  </div>
</template>
